import { jsx as _jsx } from "react/jsx-runtime";
import { FieldWrapper, } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { TagsDropdownButton } from 'components/conversation/conversationTags/components/tagsDropdownButton/tagsDropdownButton';
import { useHookFormFieldWrapper, } from 'utils/hookForm';
/**
 * Represents the React Hook Form variant of the {@link TagsDropdownButton}
 * component.
 */
export const HookFormCategorizedTagsDropdown = (props) => {
    var _a, _b;
    const { controller, controllerProps, fieldWrapperProps } = useHookFormFieldWrapper(props);
    const [selectedItems, setSelectedItems] = useState((_b = ((_a = controllerProps.defaultValue) !== null && _a !== void 0 ? _a : props.componentProps.selectedItems)) !== null && _b !== void 0 ? _b : []);
    // Handles calling React Hook Form change event because the select component
    // doesn't conform to what.
    useUpdateEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        (_b = (_a = props.componentProps).onSelect) === null || _b === void 0 ? void 0 : _b.call(_a, selectedItems);
        (_d = (_c = props.componentProps).onChange) === null || _d === void 0 ? void 0 : _d.call(_c, selectedItems);
        (_f = (_e = controller.field).onChange) === null || _f === void 0 ? void 0 : _f.call(_e, selectedItems);
    }, [controller.field.onChange, selectedItems]);
    const handleChange = ({ selectedItem: { isSelected, value: tag }, }) => {
        setSelectedItems(isSelected
            ? selectedItems.concat(tag)
            : selectedItems.filter(({ id }) => id !== tag.id));
    };
    return (_jsx(FieldWrapper, Object.assign({}, fieldWrapperProps, { children: _jsx(TagsDropdownButton, { tags: selectedItems, onChange: handleChange, isLoading: false }) })));
};
